export class Primary {
  constructor() {
    this.name = 'Primary'
    this.content = {
      showCategories: true,
      showTags: true,
      showAuthor: true,
      showDescription: true,
      showTitle: true,
      showReadMore: true,
      readMoreText: 'Read More',
      showPublishedDate: true,
      showImage: true,
      blocks: [
        'BlogPostsCategories',
        'BlogPostsTitle',
        'BlogPostsDescription',
        'BlogPostsAuthor',
        'BlogPostsDate',
        'BlogPostsTags',
        'BlogPostsReadMore',
      ],
      filter: {
        filterBy: 'TAG',
        filterId: 1,
        filterQuantity: 4,
        filterSortBy: 'title',
        filterOrderBy: 'DESC',
        filterPostsIds: '',
      },
      postsGrid: 4,
    }
    this.view = this.viewHtml()
  }

  viewHtml() {
    return `<div>blog posts primary</div>`
  }

  readMoreContainerClasses() {
    return [
      {property: 'TextAlignment', value: 'RIGHT'},
      {property: 'MarginTop', value: 'MARGIN_TOP_XS'},
    ]
  }

  tagsClasses() {
    return [
      {property: 'Rounded', value: 'ROUNDED_NONE'},
      {property: 'FontSize', value: 'FONT_SIZE_XS'},
      {property: 'FontWeight', value: 'NORMAL'},
      {property: 'MarginTop', value: 'MARGIN_TOP_XXS'},
      {property: 'MarginRight', value: 'MARGIN_RIGHT_XXS'},
      {property: 'PaddingTop', value: 'PADDING_TOP_NONE'},
      {property: 'PaddingBottom', value: 'PADDING_BOTTOM_NONE'},
      {property: 'PaddingLeft', value: 'PADDING_LEFT_NONE'},
      {property: 'PaddingRight', value: 'PADDING_RIGHT_NONE'},
    ]
  }

  tagsStyles() {
    return [
      {property:'TextColor', styleProperty: 'color', value: '#5244cc'},
    ]
  }

  contentClasses() {
    return [
      {property: 'PaddingTop', value: 'PADDING_TOP_XS'},
      {property: 'PaddingBottom', value: 'PADDING_BOTTOM_XS'},
      {property: 'PaddingLeft', value: 'PADDING_LEFT_XS'},
      {property: 'PaddingRight', value: 'PADDING_RIGHT_XS'},
    ]
  }

  contentStyles() {
    return [
      {property:'BackgroundColor', styleProperty: 'background-image', value: 'linear-gradient(0deg,#ffffff,#ffffff)'},
    ]
  }

  authorClasses() {
    return [
      {property: 'FontSize', value: 'FONT_SIZE_XS'},
      {property: 'FontWeight', value: 'BOLD'},
      {property: 'MarginTop', value: 'MARGIN_TOP_XS'},
    ]
  }

  authorStyles() {
    return [
      {property:'TextColor', styleProperty: 'color', value: '#000000'},
    ]
  }

  categoriesClasses() {
    return [
      {property: 'Rounded', value: 'ROUNDED_FULL'},
      {property: 'FontSize', value: 'FONT_SIZE_XXS'},
      {property: 'FontWeight', value: 'BOLD'},
      {property: 'MarginRight', value: 'MARGIN_RIGHT_XXS'},
      {property: 'PaddingTop', value: 'PADDING_TOP_XXXS'},
      {property: 'PaddingBottom', value: 'PADDING_BOTTOM_XXXS'},
      {property: 'PaddingLeft', value: 'PADDING_LEFT_XXS'},
      {property: 'PaddingRight', value: 'PADDING_RIGHT_XXS'},
    ]
  }

  categoriesStyles() {
    return [
      {property:'TextColor', styleProperty: 'color', value: '#5244cc'},
      {property:'BackgroundColor', styleProperty: 'background-image', value: 'linear-gradient(0deg,#e4edff,#e4edff)'},
    ]
  }

  readMoreClasses() {
    return [
      {property: 'FontSize', value: 'FONT_SIZE_SM'},
      {property: 'FontWeight', value: 'NORMAL'},
      {property: 'PaddingTop', value: 'PADDING_TOP_NONE'},
      {property: 'PaddingBottom', value: 'PADDING_BOTTOM_NONE'},
      {property: 'PaddingLeft', value: 'PADDING_LEFT_NONE'},
      {property: 'PaddingRight', value: 'PADDING_RIGHT_NONE'},
    ]
  }

  readMoreStyles() {
    return [
      {property:'TextColor', styleProperty: 'color', value: '#5244cc'},
    ]
  }

  titleClasses() {
    return [
      {property: 'FontSize', value: 'FONT_SIZE_BASE'},
      {property: 'FontWeight', value: 'BOLD'},
      {property: 'MarginTop', value: 'MARGIN_TOP_XS'},
    ]
  }

  titleStyles() {
    return [
      {property:'TextColor', styleProperty: 'color', value: '#000000'},
    ]
  }

  descriptionClasses() {
    return [
      {property: 'FontSize', value: 'FONT_SIZE_SM'},
      {property: 'FontWeight', value: 'NORMAL'},
    ]
  }

  descriptionStyles() {
    return [
      {property:'TextColor', styleProperty: 'color', value: '#888888'},
    ]
  }

  dateClasses() {
    return [
      {property: 'FontSize', value: 'FONT_SIZE_XS'},
      {property: 'FontWeight', value: 'NORMAL'},
    ]
  }

  dateStyles() {
    return [
      {property:'TextColor', styleProperty: 'color', value: '#888888'},
    ]
  }

  classes() {
    return [
      {property: 'Rounded', value: 'ROUNDED_LG'},
      {property: 'Shadow', value: 'SHADOW_MD'},
      {property: 'PaddingTop', value: 'PADDING_TOP_NONE'},
      {property: 'PaddingBottom', value: 'PADDING_BOTTOM_NONE'},
      {property: 'PaddingLeft', value: 'PADDING_LEFT_NONE'},
      {property: 'PaddingRight', value: 'PADDING_RIGHT_NONE'},
    ]
  }

  styles() {
    return [
      //
    ]
  }

  buildData() {
    return {
      name: this.name,
      view: this.view,
    }
  }

  editorProperties() {
    return {
      content: this.content,
      titleClasses: {
        phone: this.titleClasses(),
        tablet: this.titleClasses(),
        desktop: this.titleClasses(),
      },
      titleStyles: {
        phone: this.titleStyles(),
        tablet: this.titleStyles(),
        desktop: this.titleStyles(),
      },
      categoriesClasses: {
        phone: this.categoriesClasses(),
        tablet: this.categoriesClasses(),
        desktop: this.categoriesClasses(),
      },
      categoriesStyles: {
        phone: this.categoriesStyles(),
        tablet: this.categoriesStyles(),
        desktop: this.categoriesStyles(),
      },
      tagsClasses: {
        phone: this.tagsClasses(),
        tablet: this.tagsClasses(),
        desktop: this.tagsClasses(),
      },
      tagsStyles: {
        phone: this.tagsStyles(),
        tablet: this.tagsStyles(),
        desktop: this.tagsStyles(),
      },
      authorClasses: {
        phone: this.authorClasses(),
        tablet: this.authorClasses(),
        desktop: this.authorClasses(),
      },
      authorStyles: {
        phone: this.authorStyles(),
        tablet: this.authorStyles(),
        desktop: this.authorStyles(),
      },
      descriptionClasses: {
        phone: this.descriptionClasses(),
        tablet: this.descriptionClasses(),
        desktop: this.descriptionClasses(),
      },
      descriptionStyles: {
        phone: this.descriptionStyles(),
        tablet: this.descriptionStyles(),
        desktop: this.descriptionStyles(),
      },
      readMoreClasses: {
        phone: this.readMoreClasses(),
        tablet: this.readMoreClasses(),
        desktop: this.readMoreClasses(),
      },
      readMoreStyles: {
        phone: this.readMoreStyles(),
        tablet: this.readMoreStyles(),
        desktop: this.readMoreStyles(),
      },
      readMoreContainerClasses: {
        phone: this.readMoreContainerClasses(),
        tablet: this.readMoreContainerClasses(),
        desktop: this.readMoreContainerClasses(),
      },
      contentClasses: {
        phone: this.contentClasses(),
        tablet: this.contentClasses(),
        desktop: this.contentClasses(),
      },
      contentStyles: {
        phone: this.contentStyles(),
        tablet: this.contentStyles(),
        desktop: this.contentStyles(),
      },
      dateClasses: {
        phone: this.dateClasses(),
        tablet: this.dateClasses(),
        desktop: this.dateClasses(),
      },
      dateStyles: {
        phone: this.dateStyles(),
        tablet: this.dateStyles(),
        desktop: this.dateStyles(),
      },
      styles: {
        phone: this.styles(),
        tablet: this.styles(),
        desktop: this.styles(),
      },
      classes: {
        phone: this.classes(),
        tablet: this.classes(),
        desktop: this.classes(),
      },
    }
  }
}